<template>
  <div class="text-center">
    <v-dialog v-model="dialogCodesOpen" width="800" :persistent="loading">
      <template v-slot:activator="{ on, attrs }">
        <v-btn color="success" dark v-bind="attrs" v-on="on"> Send </v-btn>
      </template>

      <v-card>
        <v-card-title class="headline grey lighten-2"> Are you sure? </v-card-title>

        <v-card-text>
          <div class="title mt-6 mb-3">Registration codes will be sent to the following doctors</div>
          <div class="column_wrapper">
            <div v-for="doctor in doctors" :key="doctor.id">{{ doctor.name }}</div>
          </div>
          <div class="title mt-6 mb-3">Test types selected:</div>
          <div class="subtitle-1" v-for="testType in allowedTestTypes" :key="testType + 'test-type'">{{ getTestTypeLabel(testType) }}</div>
          <div class="title mt-6 mb-3">Amount of codes: {{ selectedAmountCodes }}</div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn text @click="dialogCodesOpen = false" :disabled="loading"> Cancel </v-btn>
          <v-btn color="primary" @click="sendCodes()" :disabled="loading" :loading="loading"> Yes </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { TestTypes } from '@/components/test-types/data/test-types.js';
export default {
  props: ['doctors', 'selectedAmountCodes', 'allowedTestTypes'],
  data() {
    return {
      dialogCodesOpen: false,
      loading: false,
      testTypeData: new TestTypes()
    };
  },
  methods: {
    sendCodes() {
      this.loading = true;
      let doctorIdArray = this.doctors.map((doctor) => doctor.id);
      let payload = {
        doctorIdArray: doctorIdArray,
        selectedAmountCodes: this.selectedAmountCodes,
        testTypes: this.allowedTestTypes
      };
      this.$store
        .dispatch('doctorOptionsStore/submitDoctorCodes', payload)
        .then((result) => {
          if (result) {
            this.dialogCodesOpen = false;
            let dataSnackbar = {
              open: true,
              text: 'Emails successfully sent',
              color: 'success'
            };
            this.$store.commit('SET_SNACKBAR', dataSnackbar);
          }
        })
        .finally(() => (this.loading = false));
    },
    getTestTypeLabel(id) {
      const selectedTest = this.testTypeData.filter((test) => id == test.value)[0];
      return selectedTest.label;
    }
  }
};
</script>

<style lang="scss" scoped>
.column_wrapper {
  column-count: 3;
}
</style>